<button (click)="switchLang()" [ngClass]="type">
  {{ 'language.switchTo' | translate }}
</button>